import { Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { NotfoundPageComponent } from './pages/notfound-page/notfound-page.component';
import { ContactPageComponent } from './pages/contact-page/contact-page.component';
import { ConfirmPageComponent } from './pages/confirm-page/confirm-page.component';
import { LoginComponent } from './auth/pages/login/login.component';
import { NewPasswordComponent } from './auth/pages/new-password/new-password.component';
import { ClientAreaComponent } from './pages/client-area/pages/client-area/client-area.component';
import { ModifyDataComponent } from './pages/client-area/pages/modify-data/modify-data.component';
import { authGuard } from './auth/services/auth.guard.service';
import { ClaimsManagementComponent } from './pages/client-area/pages/claims-management/claims-management.component';
import { ClaimsStateComponent } from './pages/client-area/pages/claims-state/claims-state.component';
import { NewClaimComponent } from './pages/client-area/pages/new-claim/new-claim.component';
import { HistoryPolicyComponent } from './pages/client-area/pages/history-policy/history-policy.component';
import { PolicyDetailsComponent } from './pages/client-area/pages/policy-details/policy-details.component';

export const routes: Routes = [
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        // ToDo: agregar guards para que no sea accesible escribiendo ruta a mano
        path: 'reset-password',
        component: NewPasswordComponent,
      },
    ],
  },
  {
    path: 'area-cliente',
    children: [
      {
        path: '',
        component: ClientAreaComponent,
      },
      {
        path: 'historial-polizas',
        component: HistoryPolicyComponent,
      },
      {
        path : 'historial-polizas/detalles',
        component: PolicyDetailsComponent,
      },
      {
        path: 'modificar-datos',
        component: ModifyDataComponent,
      },
      {
        path: 'gestion-siniestros',
        component: ClaimsManagementComponent,
      },
      {
        path: 'gestion-siniestros/estado',
        component: ClaimsStateComponent,
      },
      {
        path: 'gestion-siniestros/nuevo',
        component: NewClaimComponent,
      },
    ],
    canActivate: [authGuard]
  },
  { path: '', component: HomePageComponent },
  {
    path: 'contratacion-poliza',
    pathMatch: 'full',
    component: ContactPageComponent,
  },
  { path: 'contratacion-poliza/confirmacion', component: ConfirmPageComponent },
  { path: '**', component: NotfoundPageComponent },
];
